import React from 'react';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';

import { SemanticPlaceholder } from '../assets/components';
import { useShortcode } from '../assets/hooks';

export function Shortcode({ data, ...rest }) {
  const { rendered } = data;
  const [ref, result, loaded, error] = useShortcode(rendered);

  return (
    <Dimmer.Dimmable as={Segment} dimmed={!loaded} inverted={error} basic>
      <Dimmer active={!loaded}>
        <Loader>{error ? 'Something went wrong :(' : 'Loading'}</Loader>
      </Dimmer>

      {!loaded && <SemanticPlaceholder inverted={error} />}
      <div ref={ref} dangerouslySetInnerHTML={{ __html: loaded ? result.rendered : '' }} />
    </Dimmer.Dimmable>
  );
}
